import { ReactNode } from 'react';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { cn } from '@/lib/utils';

interface CollapsableCardProps {
  title: string;
  className?: string;
  children?: ReactNode;
  hideContent?: boolean;
  onClickTitle?: () => void;
}

export const CollapsableCard = ({
  title,
  className = '',
  children,
  hideContent,
  onClickTitle,
}: CollapsableCardProps) => {
  return (
    <Accordion
      type="single"
      className={cn(
        className,
        'w-full overflow-hidden rounded-sm border border-solid border-[#DADADA]'
      )}
      style={{ boxShadow: '4px 4px 15px 0 rgba(0, 0, 0, 0.15)' }}
      defaultValue="collapsable-card"
      collapsible
    >
      <AccordionItem value="collapsable-card">
        <AccordionTrigger
          className="flex min-h-[40px] cursor-pointer items-center rounded-b-sm bg-text-primary py-2"
          onClick={onClickTitle}
          hideArrow
        >
          <span className="px-5 text-sm font-semibold text-white">{title}</span>
        </AccordionTrigger>
        {!hideContent ? (
          <AccordionContent className="bg-white px-3 py-2 lg:px-4 lg:py-3">
            {children}
          </AccordionContent>
        ) : null}
      </AccordionItem>
    </Accordion>
  );
};
